import { SearchUser } from "../../../../store/slices/GlobalSearchSlice";
import BuildingIcon16 from "../../../../assets/BuildingIcon16";
import { getUserStatus, ROLE_DISPLAY } from "../utils";

interface UserResultRowProps {
    user: SearchUser;
    onClick: (user: SearchUser) => void;
}

const UserResultRow = ({ user, onClick }: UserResultRowProps) => {
    const userStatus = getUserStatus(user);
    const isDeactivated = !user.isActive && user.deactivatedAt;

    return (
        <div
            onClick={() => onClick(user)}
            className="flex items-center justify-between h-[72px] px-6 border-b border-shadowborder cursor-pointer hover:bg-gray-50 transition-colors"
        >
            <div className="flex items-center gap-3">
                <p className="text-sm font-medium text-texthead">
                    {user.first} {user.last}
                </p>
            </div>
            <div className="flex items-center gap-3">
                {/* Status Badge */}
                <div className="flex items-center gap-3 border border-brColor rounded-full px-3 py-2 shadow-light-sm">
                    <span className="text-sm font-medium text-texthead">
                        {userStatus.label}
                    </span>
                    <span className={`w-[7px] h-[7px] rounded-full ${userStatus.color}`} />
                </div>
                {/* Organization Badge */}
                <div className="flex items-center gap-1 border border-brColor rounded-full px-3 py-2 shadow-light-sm">
                    <span className="shrink-0">
                        <BuildingIcon16 />
                    </span>
                    <span className="text-sm font-medium text-texthead">
                        {user.organization.name}
                    </span>
                </div>
                {/* Role Badge */}
                <div className="border border-brColor rounded-full px-3 py-2 shadow-light-sm">
                    <span className={`text-sm font-medium ${isDeactivated ? "text-red-400" : "text-texthead"}`}>
                        {ROLE_DISPLAY[user.role] || user.role}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default UserResultRow;
